
import { Options, Vue } from 'vue-class-component';
import ProfileService from '@/services/ProfileService';
import EventBusService from "@/services/EventBusService";

@Options({
    props: {
        /*type: { // later if we should have different file uploads
            type: String,
            required: true
        },*/
        avatarUrl: {
            type: String,
            required: false,
            default: '',
        }
    },
    components: {

    },
    emits: [
        'uploaded'
    ],
})
export default class ProfileAvatarUpload extends Vue {
    avatarUrl!: string

    //preselectRegion?: number|null
    loading = false
    //files: [],
    uploadReady = true

    $refs!: {
        files: HTMLInputElement,
    }

    openFileSelector() {
        this.$refs.files.click();
    }

    clearFileInput() {
        this.uploadReady = false;
        this.$nextTick(() => this.uploadReady = true);
    }

    handleFilesChanged() {
        if( this.loading ) {
            return;
        }

        if( !this.$refs.files.files || this.$refs.files.files.length < 1 ) {
            return;
        }

        //console.log(this.$refs.files.files);

        const file = this.$refs.files.files[0];

        /*if( !this.checkFile(file) ) {
            return;
        }*/

        this.loading = true;

        const formData = new FormData();
        formData.append('file', file);

        ProfileService.uploadAvatar(formData).then(result => {
            this.$emit('uploaded', result.data.url);

            EventBusService.$notification({
                type: 'success',
                title: 'Profilbild aktualisiert',
                message: 'Dein Profilbild wurde erfolgreich aktualisiert.',
            });

        }).catch(error => {
            console.warn(error.response);

            let message = error.response?.data?.errors?.file?.join('<br>') || 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.';

            EventBusService.$notification({
                type: 'error',
                title: 'Profilbild konnte nicht aktualisiert werden',
                message: message,
            });
        }).finally(() => {
            this.loading = false;
            this.clearFileInput();
        });
    }

    checkFile(file: File) {
        if( file.size && file.size >= 1024 * 1024 * 2 ) {
            EventBusService.$notification({
                type: 'error',
                title: 'Datei ist zu groß',
                message: 'Die Datei darf nicht größer als 2 MB sein.'
            });

            return false;
        }

        if( file.type && ['image/jpg', 'image/jpeg', 'image/png'].indexOf(file.type) === -1 ) {
            EventBusService.$notification({
                type: 'error',
                title: 'Unerlaubter Dateityp',
                message: 'Es können nur .jpg oder .png Bilder hochgeladen werden.'
            });

            return false;
        }

        return true;
    }

    mounted() {
        EventBusService.$on('user.profile.avatar.openFileSelector', this.openFileSelector);
    }
    beforeUnmount() {
        EventBusService.$off('user.profile.avatar.openFileSelector', this.openFileSelector);
    }
}
